import { useValue } from '@tldraw/state-react';

const DEFAULT_BUFFER_PX = 400;

function rectsIntersect(a, b) {
  return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
}

/**
 * True when a pin card's page bounds overlap the editor viewport (with prefetch buffer).
 * Subscribes to camera movement so off-screen canvas pins can defer image fetches.
 */
export function usePinCardInViewport(editor, shape, bufferPx = DEFAULT_BUFFER_PX) {
  return useValue(
    'pin-card-in-viewport',
    () => {
      const viewport = editor.getViewportPageBounds?.();
      if (!viewport) return true;

      const zoom = editor.getCamera().z || 1;
      const buffer = bufferPx / zoom;

      const shapeBounds = {
        x: shape.x - buffer,
        y: shape.y - buffer,
        w: shape.props.w + buffer * 2,
        h: shape.props.h + buffer * 2,
      };

      return rectsIntersect(viewport, shapeBounds);
    },
    [editor, shape.id, shape.x, shape.y, shape.props.w, shape.props.h, bufferPx]
  );
}
